/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetReminderDetailQueryResponse,
  GetReminderDetailPathParams,
  GetReminderDetail400,
  GetReminderDetail404,
  GetReminderDetail500,
} from '../../types/GetReminderDetail'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getReminderDetail } from '../../clients/getReminderDetail'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getReminderDetailQueryKey = ({
  id,
}: {
  id: GetReminderDetailPathParams['id']
}) => [{ url: '/api/v1/reminders/reminders/:id/', params: { id: id } }] as const

export type GetReminderDetailQueryKey = ReturnType<
  typeof getReminderDetailQueryKey
>

export function getReminderDetailQueryOptions(
  { id }: { id: GetReminderDetailPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getReminderDetailQueryKey({ id })
  return queryOptions<
    GetReminderDetailQueryResponse,
    ResponseErrorConfig<
      GetReminderDetail400 | GetReminderDetail404 | GetReminderDetail500
    >,
    GetReminderDetailQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getReminderDetail(
        { id: id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Get detailed information about a specific reminder.
 * Delegates to GetReminderDetailUsecase for business logic.
 * @summary Get detail for a single reminder
 * {@link /api/v1/reminders/reminders/:id/}
 */
export function useGetReminderDetail<
  TData = GetReminderDetailQueryResponse,
  TQueryData = GetReminderDetailQueryResponse,
  TQueryKey extends QueryKey = GetReminderDetailQueryKey,
>(
  { id }: { id: GetReminderDetailPathParams['id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetReminderDetailQueryResponse,
        ResponseErrorConfig<
          GetReminderDetail400 | GetReminderDetail404 | GetReminderDetail500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getReminderDetailQueryKey({ id })

  const query = useQuery(
    {
      ...getReminderDetailQueryOptions({ id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetReminderDetail400 | GetReminderDetail404 | GetReminderDetail500
    >
  > & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}
